import styled from '@emotion/styled';
import { spacing } from 'theme';

export const OppCommitment = styled.div({
  '& > * + *': {
    marginTop: spacing[8],
  },
});
